import React from "react";
import { Form as FormControl, Col, Row, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { FormControlsValues } from "./OffenceStepTypes";

type Props = {
  formikProps: FormikProps<FormControlsValues>;
};
const LocationCommentTextArea = ({ formikProps }: Props) => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors, touched } = formikProps;

  return (
    <Row className="mb-3">
      <FormControl.Group as={Col} md="12" className="m-3">
        <Form.Label className="text-right">{t("locationComment")}</Form.Label>
        <FormControl.Control
          as="textarea"
          size="lg"
          name="locationComment"
          value={values?.locationComment}
          onChange={(event) => {
            setFieldValue("locationComment", event.target.value);
          }}
          className="square border border-secondary form-control report-input"
          isInvalid={touched.locationComment && !!errors?.locationComment}
          maxLength={1000}
          rows={8}
          style={{ height: "160px" }}
        />

        {errors?.locationComment && (
          <FormControl.Control.Feedback type="invalid">
            {errors.locationComment}
          </FormControl.Control.Feedback>
        )}
      </FormControl.Group>
    </Row>
  );
};

export default LocationCommentTextArea;
